// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f87b3a01","455":"57be7482","977":"a583f30d"}[chunkId] + ".chunk.js";
};